<template>
  <div id="app">
    <h1>The Muskets & Tomahawks card deck for remote gaming</h1>
    <hr>
    <welcome-view v-if="!isGameOn"
                  :duplicateGame="duplicateGame"
                  @create="createGame"
                  @join="joinGame"></welcome-view>
    <game-view v-else=""
               :game-name="gameName"
               :state="gameState"
               :mode="mode"
               @duplicateGame="onDuplicateGame"></game-view>
  </div>
</template>

<script>
import GameView from './components/GameView.vue';
import Vue from 'vue';
import VTooltip from 'v-tooltip';
import WelcomeView from '@/components/WelcomeView';

Vue.use(VTooltip);
export default {
  name: 'App',
  components: {
    GameView,
    WelcomeView,
  },
  data() {
    return {
      mode: null,
      gameName: null,
      gameState: null,
      isGameOn: false,
      duplicateGame: false,
    };
  },
  methods: {
    createGame({ gameName, gameState }) {
      this.mode = 'create';
      this.gameName = gameName;
      this.isGameOn = true;
      this.gameState = gameState;
    },
    joinGame(name) {
      this.mode = 'join';
      this.gameName = name;
      this.isGameOn = true;
    },
    onDuplicateGame() {
      this.mode = null;
      this.gameName = null;
      this.isGameOn = false;
      this.duplicateGame = true;
    },
  }
};
</script>

<style lang="scss">

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes bounce-in-big {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(3);
  }
  100% {
    transform: scale(2);
  }
}

.bounce {
  animation: bounce-in-big .2s;
}

html {
  margin: 0;
  padding: 0;
}

body {
  background: #8c7b57;
  background: linear-gradient(#675c40, #8c7b57);
  min-height: 100vh;
}

#app {
  font-family: 'Libre Baskerville', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #ffffffcc;
  padding: 16px;
  font-size: 1.2rem;
}

input, button {
  font-family: 'Montserrat', Arial, sans-serif;
}

h1 {
  font-size: 2vw;
  text-align: center;
  color: #ffffff99;
  margin-top: 0;
}

hr {
  margin-bottom: 1.6vw;
  border-color: #ffffff66;
}

.btn {
  color: #fff;
  background: #333;
  font-weight: bold;
  border: none;
  border-radius: 0.4vw;
  //font-family: 'Rock Salt';

  box-shadow: 0 2px 4px #00000033;
  cursor: pointer;
  padding: 0.8vw 1.4vw;

  font-size: 1vw;

  &:hover {
    background: red;
  }

  &:disabled {
    background: #999;
    cursor: not-allowed;
  }
}

.tooltip {
  display: block !important;
  z-index: 10000;
  font-family: 'Montserrat';

  .tooltip-inner {
    background: black;
    color: white;
    border-radius: 16px;
    padding: 5px 10px 6px;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: black;
    z-index: 1;
  }

  &[x-placement^="top"] {
    margin-bottom: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &.popover {
    $color: #f9f9f9;

    .popover-inner {
      background: $color;
      color: black;
      padding: 24px;
      border-radius: 5px;
      box-shadow: 0 5px 30px rgba(black, .1);
    }

    .popover-arrow {
      border-color: $color;
    }
  }

  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }

  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }
}
</style>
